import React from 'react'
import { StackView } from '@planningcenter/tapestry-react'
import { PageHeading, Text, Code, CodeBlock } from '../../shared/typography'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>File Uploads</PageHeading>

      <Text>
        Upload a file by making a <Code>POST</Code> request to
        <Code>https://upload.planningcenteronline.com/v2/files</Code>. Your
        request should use <Code>multipart/form-data</Code> encoding and contain
        a <Code>file</Code> attribute with the file data. Here’s how to upload a
        file with curl:
      </Text>

      <CodeBlock language="bash">
        {
          "curl -u app_id:secret -X POST -F 'file=@/path/to/file.png' https://upload.planningcenteronline.com/v2/files"
        }
      </CodeBlock>

      <Text>
        The response you get will contain an <Code>id</Code> which is the file
        UUID.
      </Text>

      <CodeBlock language="json">
        {JSON.stringify(
          {
            data: [
              {
                type: 'File',
                id: 'us1-16207df7-b6cc-4abe-ca1a-306c6f7e423d',
                attributes: {
                  source_ip: '70.128.100.145',
                  md5: 'e178604e5083cc23782f34650a49b025',
                  content_type: 'image/png',
                  file_size: 48341,
                  name: 'file.png',
                  expires_at: '2016-05-23T23:13:32Z',
                },
              },
            ],
          },
          null,
          2
        )}
      </CodeBlock>

      <Text>
        Pass the UUID as the attribute value to an endpoint that accepts a file.
        The UUID is a string that tells the endpoint which file to associate.
      </Text>

      <Text>
        To assign the file to an attribute, pass the UUID as a string. For
        example, here is how to update the Person avatar:
      </Text>
      <CodeBlock language="bash">
        {
          'curl -u app_id:secret -X PATCH https://api.planningcenteronline.com/people/v2/people/1 -d \'{"data":{"attributes":{"avatar":"us1-16207df7-b6cc-4abe-ca1a-306c6f7e423d"}}}\''
        }
      </CodeBlock>
    </StackView>
  )
}

export default page
